module.exports = __webpack_public_path__ + "img/202402_01.9538b1f2.jpg";